import { typo, ActionButton, Input } from '@cycle-app/ui';
import { motion } from 'framer-motion';
import styled from 'styled-components';

export const SECTIONS_GAP = 8;

export const PageContainer = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  gap: ${SECTIONS_GAP}px;
  margin: 8px;
`;

export const Section = styled(motion.div)`
  flex: 1;
  height: 100%;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0px 0px 2px 1px rgba(0, 0, 0, 0.06);
  background: ${p => p.theme.colors.releases.bg};
`;

export const SectionContainer = styled.div`
  position: relative;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div<{ $borderless?: boolean }>`
  min-height: 56px;
  padding: 12px 16px;
  border-bottom: 1px solid ${p => (p.$borderless ? 'transparent' : p.theme.colors.releases.border)};
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;

  h1 {
    ${typo.headerLight}
  }
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const Action = styled(ActionButton)`
  --colorHover: ${p => p.theme.colors.text.secondary};

  /* stylelint-disable-next-line no-duplicate-selectors */
  ${Actions} & {
    width: 28px;
    height: 28px;
  }
`;

export const HeaderButton = styled(ActionButton)`
  width: 28px;
  height: 28px;
`;

export const SearchInput = styled(Input)`
  input {
    height: 28px;
  }
`;
